import type { Dispatch, SetStateAction } from 'react';
import { Checkbox, Menu, MenuItem, MenuButton, Dropdown } from '@mui/joy';
import Icon from '@standardsdigital/ui-components/Icon';
import IconButton from '@standardsdigital/ui-components/IconButton';
import type { SubscriptionModel } from 'redux/services/api.generated';
import { useTranslation } from 'react-i18next';
import styles from './SubscriptionFilters.module.css';
import type { SubscriptionStatuses } from 'components/pages/Subscriptions/subscriptionTypes';
import { initialSubscriptionStatuses } from 'components/pages/Subscriptions/subscriptionStatusDefaults';

interface SubscriptionFiltersProps {
  statuses: SubscriptionStatuses;
  setStatuses: Dispatch<SetStateAction<SubscriptionStatuses>>;
}

function SubscriptionFilters({ statuses, setStatuses }: SubscriptionFiltersProps) {
  const { t } = useTranslation();

  const toggleStatus = (key: string) => {
    setStatuses((prevStatuses) => ({
      ...prevStatuses,
      [key]: !prevStatuses[key as keyof typeof prevStatuses],
    }));
  };

  return (
    <Dropdown>
      <MenuButton
        slots={{ root: IconButton }}
        slotProps={{
          root: { size: 'small', icon: 'ChevronDown', layout: 'icon-end' },
        }}
      >
        {t('labels.status')}
      </MenuButton>
      <Menu role="listbox" className={styles.menu}>
        <MenuItem
          className={styles.resetStatuses}
          onClick={() => setStatuses(initialSubscriptionStatuses)}
        >
          <IconButton
            icon="X"
            variant="text"
            layout="icon-only"
            size="small"
            className={styles.xIcon}
          >
            {t('general.resetStatuses')}
          </IconButton>
          <span>{t('general.resetStatuses')}</span>
        </MenuItem>
        {Object.entries(statuses).map(([key, value]) => (
          <MenuItem
            key={key}
            role="option"
            onClick={() => toggleStatus(key)}
            className={styles.menuItem}
          >
            <Checkbox
              checkedIcon={<Icon name="Check" />}
              checked={value || false}
              label={t(
                `subscriptionStatuses.${
                  key as SubscriptionModel['subscriptionStatus']
                }`,
              )}
              size="sm"
              overlay
            />
          </MenuItem>
        ))}
      </Menu>
    </Dropdown>
  );
}

export default SubscriptionFilters;
